import { plainToInstance, Type } from 'class-transformer'
import i18n from 'vue-i18n'

import { MenuSectionNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import SampleSendMessageNode from '../ui/SampleNode/SampleSendMessageNode.vue'
import SendMessageSidebar from '../ui/Sidebar/SendMessageSidebar.vue'
import ProxySendMessageData from './Proxy/ProxySendMessageData'
import ProxySendMessageAction from './Proxy/actions/ProxySendMessageAction'
import ProxyTypingAction from './Proxy/actions/ProxyTypingAction'
import ProxyUserInputAction from './Proxy/actions/ProxyUserInputAction'
import BaseSendMessageAction from './actions/BaseAction'
import SendMessageAction from './actions/SendMessageAction'
import TypingAction from './actions/TypingAction'
import UserInputAction from './actions/UserInputAction'
import { MessageNodeActionTypes, SendMessageNodeProps } from './types'

export default class SendMessageNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Communications
  sidebarComponent = SendMessageSidebar

  constructor(i18n: i18n, nodeProps: SendMessageNodeProps) {
    super(SampleSendMessageNode, SendMessageNode, NodeTypes.SendMessage, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(SendMessageNodeData, {
        type: NodeTypes.SendMessage,
        inactive_action: { output: CustomNode.LastSocketId += 1, time: 0 },
        actions: [ {
          type: MessageNodeActionTypes.Message,
          variants: [
            {
              text: '',
              attachments: [],
              buttons: [],
              pin: false,
              disable_link_preview: false,
              disable_notify: false,
              remove_previous: false,
              protect_content: false,
              remove_after: 0,
            }
          ]
        } ]
      }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }

}

export class SendMessageNode extends CustomNode {
  data: ProxySendMessageData

  declare nodeProps: SendMessageNodeProps

  constructor(name: NodeTypes.SendMessage, model: BaseNodeModel, nodeProps: SendMessageNodeProps) {
    super(name, model, nodeProps)
    if (model.data instanceof SendMessageNodeData) {
      this.data = new ProxySendMessageData(model.data, this.socketActions, nodeProps)
    } else {
      throw new Error('To node come unknown data')
    }
  }

  /**
   * index передается в случае создания экшена Typing, чтобы поставить его перед другими конкретными действиями
   * (так как Typing, для пользователя явзяется частью отправки сообщения или пользовательского ввода)
   * */
  createNewAction(type: MessageNodeActionTypes, index?: number): void {
    if (!index) {
      switch (type) {
        case MessageNodeActionTypes.Message:
          this.data.proxyActions.push(new ProxySendMessageAction(ProxySendMessageAction.getDefaultActionModel(), this.socketActions))
          break
        case MessageNodeActionTypes.UserInput:
          this.data.proxyActions.push(new ProxyUserInputAction(ProxyUserInputAction.getDefaultActionModel(), this.socketActions, this.nodeProps))
          break
        default:
          break
      }
    } else {
      this.data.proxyActions.splice(index, 0, new ProxyTypingAction({ type: MessageNodeActionTypes.Typing, time: 1 }))
    }
  }
}

export class SendMessageNodeData extends BaseNodeModelData {
  declare type: NodeTypes.SendMessage
  inactive_action!: {
    output: number,
    time: number
  }
  @Type(() => BaseSendMessageAction, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: MessageNodeActionTypes.Message, value: SendMessageAction },
        { name: MessageNodeActionTypes.Typing, value: TypingAction },
        { name: MessageNodeActionTypes.UserInput, value: UserInputAction },
      ]
    }
  })
  actions!: Array<BaseSendMessageAction>
}
